import { useState } from "react";
import { Col } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import { ProjectModal } from "./ProjectModal";

export const ProjectCard = ({
  title,
  description,
  overview,
  highlights,
  techStack = [],
  images = [],
  demo,
  code,
}) => {
  const [modalOpen, setModalOpen] = useState(false);
  const coverImage = images[0];

  return (
    <>
      <Col size={12} sm={6} md={4} className="mb-4">
        <article className="proj-card">
          {/* Cover image — click to open modal */}
          <div
            className="proj-cover"
            onClick={() => setModalOpen(true)}
            role="button"
            tabIndex={0}
            aria-label={`View ${title} case study`}
            onKeyDown={(e) => e.key === "Enter" && setModalOpen(true)}
          >
            {coverImage && (
              <img
                src={coverImage}
                alt={`${title} preview`}
                className="proj-cover-img"
              />
            )}
            <div className="proj-cover-overlay" aria-hidden="true">
              <span className="proj-cover-hint">View Project Detail</span>
            </div>
          </div>

          <div className="proj-content">
            <h3 className="proj-title">{title}</h3>

            <div className="proj-chips" aria-label={`${title} tech stack`}>
              {techStack.map((tech) => (
                <span className="proj-chip" key={`${title}-${tech}`}>
                  {tech}
                </span>
              ))}
            </div>

            <div className="proj-description">
              {overview || description}
            </div>

            <div className="proj-actions">
              <button
                className="proj-read-more"
                onClick={() => setModalOpen(true)}
                aria-label={`Read more about ${title}`}
              >
                Read More
              </button>
              <div className="proj-content-divider" aria-hidden="true"></div>
              {demo && (
                <Button href={demo} target="_blank" rel="noreferrer" variant="primary">
                  Project Demo
                </Button>
              )}
              <Button
                href={code}
                target="_blank"
                rel="noreferrer"
                variant="outline-warning"
              >
                View Code
              </Button>
            </div>
          </div>
        </article>
      </Col>

      <ProjectModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        title={title}
        description={description}
        overview={overview}
        highlights={highlights}
        techStack={techStack}
        images={images}
        demo={demo}
        code={code}
      />
    </>
  );
};
